<agr-dialog [data]="data" (cancel)="cancel()" (confirm)="confirmDeliveryDate()">
  <app-product-delivery-moment
    [skuId]="data.productListItem?.id"
    [allowedFlexibility]="data.productListItem?.orderingInformation?.flexibility ?? 0"
    [deliveryInformation]="data.deliveryInformation"
    (deliveryInformationIsValid)="handleDeliveryInformationIsValidChange($event)"
    (deliveryInformationChanged)="handleDeliveryInformationChange($event)"
  >
  </app-product-delivery-moment>
</agr-dialog>
